<script lang="ts">
	import ContentBlocks from "@components/ContentBlocks.svelte";
	import HugeHeading from "@components/HugeHeading.svelte";
	import ServiceStructuredData from "@components/ServiceStructuredData.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import CaseStudiesSection from "@components/sections/CaseStudiesSection.svelte";
	import type { ServicesSolutionsDetailProps } from "./ServicesSolutionsDetailProps.js";

	const { solution, caseStudies }: ServicesSolutionsDetailProps = $props();
</script>

<ServiceStructuredData {solution} />

<Layout>
	<section class="pb-8 md:pb-16 lg:pb-20 full-width grid-container flex flex-col 2k:w-[116rem] 2k:mx-auto">
		<div class="flex flex-col gap-4 mb-10 max-w-[calc(72rem+var(--container-gap)] mx-auto">
			<div class="flex flex-col gap-4 max-w-screen-md mx-auto">
				<HugeHeading level={1} text={solution.name} class="lg:!text-9xl !mb-0 mild" />
				{#if solution.description}
					<p class="text-[1.25rem]/[1.5] md:text-xl/[1.5] font-semibold max-w-screen-md">
						<Formatted text={solution.description} />
					</p>
				{/if}
			</div>
		</div>
		<ContentBlocks blocks={solution.content} lightboxIdPerBlock align="center" />
	</section>
	{#if caseStudies.length > 0}
		<CaseStudiesSection {caseStudies} heading="Případové studie" />
	{/if}
</Layout>
